export default "__VITE_ASSET__a85ca6fd__"